import { render, staticRenderFns } from "./LocalPriceInquiriesGrid.vue?vue&type=template&id=940ff4dc"
import script from "./LocalPriceInquiriesGrid.vue?vue&type=script&lang=js"
export * from "./LocalPriceInquiriesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports